import { Pipe, PipeTransform } from '@angular/core';
import Constants from '../shared/constants';
import * as moment from 'moment';

@Pipe({ name: 'shortDateFormat' })
export class ShortDateFormat implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) { return value; }
        return moment(value).format(Constants.ShortDateFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/pipes/short-date-format.pipe.ts